import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'simplediv',
  templateUrl: './simplediv.component.html',
})
export class SimpledivComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
